import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import axios from "axios";

const ResetPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showNotification, setshowNotification] = useState(false);
  const apiUrl = import.meta.env.VITE_API_URL;
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const initialValues = {
    email: "",
  };

  //VALIDATION SCHEMA
  const Validation = yup.object().shape({
    email: yup
      .string()
      .email("Please use a valid email address")
      .required("Email is required"),
  });

  //FORM SUBMISSION FUNCTION
  const submitForm = (values, { resetForm }) => {
    setIsSubmitting(true);
    localStorage.setItem("Email", values.email);
    axios
      .post(`${apiUrl}/api/v1/auth/request-otp/`, values, {
        withCredentials: true,
      })
      .then((response) => {
        setshowNotification(null);
        navigate(`/otp_validation`);
        resetForm();
        setIsSubmitting(false);
      })
      .catch((err) => {
        console.error("Error:", err);
        if (err.response) {
          const { status, data } = err.response;
          if (status === 400) {
            setshowNotification(
              data.message || "Invalid input. Please check your form data."
            );
          } else if (status === 401) {
            setshowNotification(
              data.message ||
                "Unauthorized access. Please verify your credentials."
            );
          } else if (status === 404) {
            setshowNotification(
              data.message || "The requested resource could not be found."
            );
          } else if (status === 500) {
            setshowNotification(
              data.message || "Server error. Please try again later."
            );
          } else {
            setshowNotification(
              data.message || "An error occurred. Please try again."
            );
          }
        } else if (err.request) {
          setshowNotification(
            "No response from the server. Please check your internet connection."
          );
        } else {
          setshowNotification("An unexpected error occurred.");
        }
        setTimeout(() => {
          setshowNotification(false);
        }, 5000);
        setIsSubmitting(false);
        resetForm();
      });
  };

  // CSS TRANSITION STYLES
  const styles = {
    enter: "transform translate-x-full opacity-0",
    enterActive:
      "transform -translate-x-0 opacity-100 transition-all duration-500 ease-in-out",
    exitActive:
      "transform translate-x-full opacity-0 transition-all duration-500 ease-in-out",
  };

  return (
    <>
      {/* THE FORM USING FORMIK AND YUP FOR VALIDATION */}
      <div className="flex justify-center items-center w-full h-screen">
        <Formik
          initialValues={initialValues}
          validationSchema={Validation}
          onSubmit={submitForm}
        >
          <Form className="flex items-center flex-col md:w-[50%] w-[100%]">
            <img className="mb-8 w-[200px]" src="/logo-black.png" />
            <h5 className="text-primary text-2xl font-bold mb-3">
              RESET PASSWORD
            </h5>
            <h5 className="text-primary mb-8 px-8">
              To reset your password, enter your email address.
            </h5>
            <span className="h-[1px] bg-slate-200/100"></span>

            <div className="mt-8 w-full flex items-center flex-col">
              <Field
                type="email"
                name="email"
                placeholder="Email"
                className="bg-transparent border flex items-center focus:invalid:border-danger focus:invalid:ring-danger invalid:border-danger invalid:text-danger focus:border-focus focus:ring-1 focus:ring-focus justify-between w-[70%] outline-none rounded-md p-2"
              />
              {isSubmitting ? (
                <button type="submit" disabled className="mt-8">
                  <section className="dots-container">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </section>
                </button>
              ) : (
                <button
                  type="submit"
                  className="bg-btn mt-8 w-[70%] transition border-btn border duration-300 ease-in-out text-white hover:border hover:bg-transparent hover:text-btn flex items-center justify-center cursor-pointer rounded-lg py-2"
                >
                  <div>
                    Continue &nbsp;
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                </button>
              )}

              <Link className="mt-8 text-primary cursor-pointer" to="/login">
                <small>
                  Remember your password? <u>Login</u>
                </small>
              </Link>

              <small className="mt-12 text-primary cursor-pointer">
                &copy; Trakitt HQ, {currentYear}.
              </small>
            </div>
          </Form>
        </Formik>
      </div>

      {/* THE NOTIFICATION FOR ERRORS */}
      <CSSTransition
        in={showNotification}
        classNames={styles}
        timeout={500}
        unmountOnExit
      >
        <div className="p-4 shadow-xl z-50 bg-white fixed right-3 top-10 border-s-2 border-danger rounded-md flex items-center gap-4">
          <span className="flex items-center gap-4">
            <FontAwesomeIcon className="text-danger" icon={faTimes} />
            <p className="font-light">{showNotification}</p>
          </span>
        </div>
      </CSSTransition>
    </>
  );
};

export default ResetPassword;
